<template>
    <a :href="this.device()" :class="this.classes()" target="_blank">
        <span v-if="this.type === 'link'" class="new-text-md text-link" v-html="(this.os === 'ios' ? 'iOS' : 'Android')"></span>

        <span v-if="this.type === 'black' && this.os === 'android'" class="btn-caption new-text-sm">{{ __('For Android') }}</span>
        <span v-if="this.type === 'black' && this.os === 'ios'" class="btn-caption new-text-sm">{{ __('For iPhone') }}</span>
        
        <figure v-if="this.type === 'white' || this.type === 'black'">
            <img
                v-if="this.type === 'white' && this.os === 'android'"
                loading="lazy"
                :src="`/imgs/web/svg/img_android_white_${this.lang}.svg`"
                alt="Android - Vitadio"
            />
            <img
                v-if="this.type === 'white' && this.os === 'ios'"
                loading="lazy"
                :src="`/imgs/web/svg/img_ios_white_${this.lang}.svg`"
                alt="iOS - Vitadio"
            />
            <img
                v-if="this.type === 'black' && this.os === 'android'"
                loading="lazy"
                :src="`/imgs/web/svg/img_android_${this.lang}.svg`"
                alt="Android - Vitadio"
            />
            <img
                v-if="this.type === 'black' && this.os === 'ios'"
                loading="lazy"
                :src="`/imgs/web/svg/img_ios_${this.lang}.svg`"
                alt="iOS - Vitadio"
            />
        </figure>
    </a>
</template>
<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            lang: {
                type: String,
                required: true,
                validator(value) {
                    return ['cs', 'sk', 'en', 'de', 'it'].includes(value)
                }
            },
            type: {
                type: String,
                required: false,
                default: 'link',
                validator(value) {
                    return ['black', 'white', 'link'].includes(value)
                }
            },
            os: {
                type: String,
                required: true,
                validator(value) {
                    return ['ios', 'android'].includes(value)
                }
            }
        },
        data() {
            return {
                links: {
                    android: {
                        de: 'https://bit.ly/vitadio-android-de',
                        other: 'https://bit.ly/vitadio-android'
                    },
                    ios: {
                        de: 'https://bit.ly/vitadio-iOS-de',
                        other: 'https://bit.ly/vitadio-ios'
                    }
                },
                localLinks: {
                    cs: '/stahnout-aplikaci',
                    sk: '/stiahnut-aplikaciu',
                    de: '/app-herunterladen',
                    en: '/download-app',
                    it: '/installa-app',
                }
            }
        },
        created() {
            this.device()             
            this.classes()
        },
        methods: {
            classes() {
                if (this.disabled) {
                    return 'disabled'
                }

                if (this.type === 'black') {
                    if (this.os === 'ios') {
                        if (this.lang === 'de') {
                            return 'ios de'
                        }
                        return 'ios'
                    } else {
                        return this.lang === 'de' ? 'android de' : 'android'
                    }
                }
                
                if (this.type === 'link') {
                    return 'link'
                }

                return 
            },

            device() {
                const actualScreenWidth = window.screen.width
                if (actualScreenWidth < 768) {                    
                    if (this.lang === 'de') {
                        return this.links[this.os].de
                    }

                    return this.links[this.os].other                    
                } 

                if (this.lang === 'en') {
                    return `${this.localLinks[this.lang]}?local=en`
                }

                return this.localLinks[this.lang]
            }
        }
    }
</script>

<style scoped lang="less">
.link {
    display: inline-block;
    width: max-content;
}

.disabled {
    pointer-events: none;
}
</style>
